import { z } from 'zod'

export const GUEST_UPGRADE_ID_HEADER = 'x-argus-guest-upgrade-id'

export const gameIdSchema = z
  .string()
  .min(3)
  .regex(/^[^/\s]+\/[^/\s]+$/)
  .describe('Canonical organization/project identifier')

// Deprecated: used by the legacy service-auth-session flow.
export const sessionIdSchema = z.string().length(32)
export const handoffIdSchema = z.string().length(32)
export const upgradeIdSchema = z.string().length(32)

export const loginSchema = z.object({
  email: z.email({ message: 'Please enter a valid email address' }),
  password: z
    .string()
    .min(8, { message: 'Password should be at least 8 characters' })
    .max(100, { message: 'Password should be at most 100 characters' }),
})

export const registerSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  email: z.email({ message: 'Please enter a valid email address' }),
  password: z
    .string()
    .min(8, { message: 'Password should be at least 8 characters' })
    .max(100, { message: 'Password should be at most 100 characters' }),
})

export const verifySchema = z.object({
  email: z.email('Please enter a valid email address'),
  otp: z.string().regex(/^\d{6}$/, 'Invalid OTP'),
})

export const forgotPasswordSchema = z.object({
  email: z.email('Please enter a valid email address'),
})

export const resetPasswordSchema = z.object({
  password: z
    .string()
    .min(8, { message: 'Password should be at least 8 characters' })
    .max(100, { message: 'Password should be at most 100 characters' }),
})

export type LoginParams = z.infer<typeof loginSchema>
export type RegisterParams = z.infer<typeof registerSchema>
export type VerifyParams = z.infer<typeof verifySchema>
export type ForgotPasswordParams = z.infer<typeof forgotPasswordSchema>
export type ResetPasswordParams = z.infer<typeof resetPasswordSchema>
